import rootActions from "../rootActions";

class subscriptionTemplateActions extends rootActions {
  constructor(params) {
    super(params);
  }
}

export default subscriptionTemplateActions;
